import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import TournamentList from '../components/Tournaments/TournamentList';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import './TournamentsPage.css';

/**
 * Filter and sort tournaments to show only active ones.
 * A tournament is considered active if it hasn't finished (end time hasn't passed).
 * Sorted by closest start time first.
 */
function filterAndSortTournaments(tournaments) {
  if (!tournaments || tournaments.length === 0) return [];

  const now = new Date();

  // Filter tournaments that haven't finished
  const activeTournaments = tournaments.filter((tournament) => {
    if (!tournament.date) return false;

    // Parse the date and time
    const [year, month, day] = tournament.date.split('-').map(Number);
    let hour = 0;
    let minute = 0;

    if (tournament.time) {
      [hour, minute] = tournament.time.split(':').map(Number);
    }

    // Create a Date object in the browser's local timezone
    const tournamentDateTime = new Date(year, month - 1, day, hour, minute, 0);

    return tournamentDateTime > now;
  });

  // Sort by closest time first
  return activeTournaments.sort((a, b) => {
    const [aYear, aMonth, aDay] = a.date.split('-').map(Number);
    const [aHour = 0, aMinute = 0] = (a.time || '00:00').split(':').map(Number);
    const aDateTime = new Date(aYear, aMonth - 1, aDay, aHour, aMinute, 0);

    const [bYear, bMonth, bDay] = b.date.split('-').map(Number);
    const [bHour = 0, bMinute = 0] = (b.time || '00:00').split(':').map(Number);
    const bDateTime = new Date(bYear, bMonth - 1, bDay, bHour, bMinute, 0);

    return aDateTime.getTime() - bDateTime.getTime();
  });
}

export default function TournamentsPage() {
  const { data: tournaments, loading, error, refetch } = useApi(api.getTournaments);
  const { data: nonCircuitTournaments, loading: ncLoading, error: ncError, refetch: ncRefetch } = useApi(api.getNonCircuitTournaments);

  // Apply filtering and sorting to tournaments
  const activeTournaments = filterAndSortTournaments(tournaments);
  const activeNonCircuitTournaments = filterAndSortTournaments(nonCircuitTournaments);

  return (
    <div className="tournaments-page">
      <section className="tournaments-page__header section section--dark">
        <div className="container">
          <h1 className="tournaments-page__title staatliches-regular">
            Tournois Champions Collective
          </h1>
          <p className="tournaments-page__subtitle chiron-goround-tc-body">
            Inscrivez-vous aux tournois du Circuit Champions Collective !
          </p>
        </div>
      </section>

      <section className="tournaments-page__content section">
        <div className="container">
          {loading && <Loading text="Chargement des tournois..." />}
          {error && <ErrorMessage message={error} onRetry={refetch} />}
          {!loading && !error && <TournamentList tournaments={activeTournaments} />}
        </div>
      </section>

      <section className="tournaments-page__non-circuit section">
        <div className="container">
          <h2 className="tournaments-page__section-title staatliches-regular">
            Tournois mis en avant
          </h2>
          <div className="tournaments-page__warning chiron-goround-tc-body">
            Ces tournois mis en avant ne font pas partie du circuit Champions Collective !
          </div>
          {ncLoading && <Loading text="Chargement des tournois..." />}
          {ncError && <ErrorMessage message={ncError} onRetry={ncRefetch} />}
          {!ncLoading && !ncError && <TournamentList tournaments={activeNonCircuitTournaments} variant="non-circuit" />}
          <p className="tournaments-page__contact chiron-goround-tc-body">
            Souhaitez-vous mettre en avant votre tournoi Limitless ? Contactez-nous à{' '}
            <a href="mailto:championscollective@protonmail.com" className="tournaments-page__contact-link">
              championscollective@protonmail.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
